import api from './client';

async function fetchUsers(page = 0, perPage = 15, name, phone) {
    const nameFilter = name ? `&name=${name}` : ''
    const phoneFilter = phone ? `&phone=${phone}` : ''
    const url = `/customers?currentPage=${page}&perPage=${perPage}${nameFilter}${phoneFilter}`;
    const {data} = await api.get(url);
    return data;
}

async function updateGroup(id, group) {
    const url = '/customers/edit-group';
    const {data} = await api.post(url, { ids: [id], group });
    return data;
}

async function updateCompany(id, company) {
    const url = '/customers/edit-company';
    const {data} = await api.post(url, { id, company });
    return data;
}

async function updateName(id, name) {
    const url = '/customers/edit-name';
    const {data} = await api.post(url, { id, name });
    return data;
}

async function updateEmail(id, email) {
    const url = '/customers/edit-email';
    const {data} = await api.post(url, { id, email });
    return data;
}

async function updateBanned(id, banned) {
    const url = '/customers/edit-banned';
    const {data} = await api.post(url, { id, banned });
    return data;
}
export {
    fetchUsers,
    updateGroup,
    updateCompany,
    updateName,
    updateEmail,
    updateBanned,
}
